import React, { useEffect } from 'react';
// Removed: import { useParams } from 'react-router-dom';
// Removed: import { get } from '../../utility/fetch2';
// Removed: import { calculateAge } from '../../utility/general';

// Mock function for fetching data
// In a real application, this would be your actual API call
const mockGet = async (url) => {
  // Simulate API delay
  await new Promise(resolve => setTimeout(resolve, 500));
  console.log(`Mocking GET request to: ${url}`);
  // Return a hardcoded patient object for demonstration
  return {
    id: 'mock-patient-123',
    firstName: 'John',
    lastName: 'Doe',
    dateOfBirth: '1990-05-15', // Example DOB for age calculation
    gender: 'Male',
    // ... other patient details
  };
};

// Mock function for calculating age
// In a real application, this would be your actual utility function
const mockCalculateAge = (dateOfBirth) => {
  if (!dateOfBirth) return 'N/A';
  const birthDate = new Date(dateOfBirth);
  const today = new Date();
  let age = today.getFullYear() - birthDate.getFullYear();
  const m = today.getMonth() - birthDate.getMonth();
  if (m < 0 || (m === 0 && today.getDate() < birthDate.getDate())) {
    age--;
  }
  return age;
};


const VitalsRecords = ({ vitals = [] }) => {

  // Removed: const { patientId, } = useParams();
  const [patient, setPatient] = React.useState(null);

  const getPatientDetails = async () => {
    // setLoading(true); // Assuming you have a loading state to manage
    try {
      // Using the mockGet function instead of the external 'get'
      const data = await mockGet('/patients/mock-patient-id/data');
      setPatient(data);
      console.log('Mock Patient Data:', data);
      console.log('Mock Patient ID:', data?.id);

      // setVisit(data?.visits?.pop()); // Keep this if applicable in your full app
    } catch (e) {
      console.error('Error fetching mock patient details:', e);
    }
    // setLoading(false); // Assuming you have a loading state to manage
  };

  useEffect(() => {
    getPatientDetails();
    // The dependency array is empty because we don't depend on patientId from useParams anymore
    // and mockGet is stable.
  }, []);


  // Using hardcoded vitals for demonstration if none are passed in
  const displayVitals = vitals.length > 0 ? vitals : [
  //   {
  //     dateOfVisit: '2024-06-20',
  //     vitalNurseName: 'Nurse Alice',
  //     temperature: 36.8,
  //     bloodPressure: '120/80',
  //     heartPulse: 72,
  //     respiratory: 16,
  //     bloodSugar: '100 mg/dL',
  //     oxygenSaturation: '98%',
  //     height: 175,
  //     weight: 70,
  //     bmi: 22.86,
  //     notes: ['Patient in good spirits', 'Routine checkup']
  //   },
  //   {
  //     dateOfVisit: '2024-05-10',
  //     vitalNurseName: 'Nurse Bob',
  //     temperature: 37.1,
  //     bloodPressure: '130/85',
  //     heartPulse: 78,
  //     respiratory: 18,
  //     bloodSugar: '115 mg/dL',
  //     oxygenSaturation: '97%',
  //     height: 175,
  //     weight: 71,
  //     bmi: 23.18,
  //     notes: ['Complained of mild headache']
  //   }
  ];


  console.log('Vitals Records:', displayVitals);
  return (
    <>
      <style>
        {`
          /* Pure CSS for VitalsRecords Table */
          .vitals-sidebar {
            width: 100%;
            display: flex;
            justify-content: center;
            padding: 1rem;
            box-sizing: border-box; /* Include padding in element's total width and height */
            font-family: 'Inter', sans-serif; /* Ensure Inter font is used */
          }

          .vitals-container {
            background-color: #fff;
            border-radius: 0.5rem;
            box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
            width: 100%;
            max-width: 90rem; /* max-w-6xl */
            padding: 1.5rem;
            position: relative;
            overflow: hidden; /* For rounded corners */
          }

          .vitals-title {
            font-size: 1.25rem; /* text-xl */
            font-weight: 700; /* font-bold */
            margin-bottom: 1rem; /* mb-4 */
            color: #1f2937; /* Dark gray text */
          }

          .no-vitals-message {
            color: #6b7280; /* text-gray-500 */
            padding: 1rem; /* Add some padding for better spacing */
            text-align: center;
          }

          .vitals-table-wrapper {
            overflow-x: auto; /* Enable horizontal scrolling for small screens */
            -webkit-overflow-scrolling: touch; /* Smooth scrolling on iOS */
            border-radius: 0.5rem; /* Match container border-radius */
            margin-top: 1rem; /* Space between title and table */
          }

          .vitals-table {
            width: 100%;
            border-collapse: collapse; /* Ensure borders are clean */
            min-width: 800px; /* Minimum width to prevent excessive squishing */
          }

          .vitals-table thead tr {
            background-color: #e5ffe5; /* Light green from image */
          }

          .vitals-table th {
            padding: 0.75rem 1rem; /* px-4 py-3 */
            text-align: left;
            font-weight: 600; /* font-semibold */
            color: #166534; /* Darker green for text from image */
            border-bottom: 2px solid #a7f3d0; /* Subtle border */
            white-space: nowrap; /* Prevent text wrapping in headers */
          }

          .vitals-table tbody tr {
            background-color: #ffffff; /* White background for rows */
            border-bottom: 1px solid #e5e7eb; /* border-gray-200 */
          }

          .vitals-table tbody tr:last-child {
            border-bottom: none; /* No border for the last row */
          }

          .vitals-table td {
            padding: 0.75rem 1rem; /* px-4 py-3 */
            color: #4b5563; /* text-gray-700 */
            vertical-align: top; /* Align content to the top */
            white-space: nowrap; /* Prevent text wrapping in cells */
          }

          .vitals-table tbody tr:hover {
            background-color: #f9fafb; /* Light hover effect */
          }

          /* Responsive adjustments */
          @media (max-width: 768px) {
            .vitals-container {
              padding: 1rem;
            }
            .vitals-title {
              font-size: 1.125rem;
            }
            .vitals-table th, .vitals-table td {
              padding: 0.5rem 0.75rem;
              font-size: 0.875rem;
            }
          }

          @media (max-width: 480px) {
            .vitals-container {
              padding: 0.75rem;
            }
            .vitals-title {
              font-size: 1rem;
            }
            .vitals-table {
              min-width: 600px; /* Adjust min-width for very small screens */
            }
          }
        `}
      </style>

      <aside className="vitals-sidebar">
        <div className="vitals-container">
          <h2 className="vitals-title">Vitals Records</h2>
          {displayVitals.length === 0 ? (
            <p className="no-vitals-message">No vitals recorded.</p>
          ) : (
            <div className="vitals-table-wrapper">
              <table className="vitals-table">
                <thead>
                  <tr>
                    <th>Date of Visit</th>
                    <th>Nurse</th>
                    <th>Patient</th>
                    <th>Age</th>
                    <th>Sex</th>
                    <th>Temp (°C)</th>
                    <th>BP</th>
                    <th>HR</th>
                    <th>Resp</th>
                    <th>BS</th>
                    <th>O₂ Sat</th>
                    <th>Height (cm)</th>
                    <th>Weight (kg)</th>
                    <th>BMI</th>
                    <th>Notes</th>
                  </tr>
                </thead>
                <tbody>
                  {displayVitals.map((v, i) => (
                    <tr key={i}>
                      <td>{v.dateOfVisit}</td>
                      <td>{v.vitalNurseName}</td>
                      <td>{patient?.firstName} {patient?.lastName}</td>
                      <td>{patient ? mockCalculateAge(patient.dateOfBirth) : 'N/A'}</td>
                      <td>{patient?.gender}</td>
                      <td>{v.temperature}</td>
                      <td>{v.bloodPressure}</td>
                      <td>{v.heartPulse}</td>
                      <td>{v.respiratory}</td>
                      <td>{v.bloodSugar}</td>
                      <td>{v.oxygenSaturation}</td>
                      <td>{v.height}</td>
                      <td>{v.weight}</td>
                      <td>{v.bmi}</td>
                      <td>{v.notes?.join(', ') || '-'}</td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          )}
        </div>
      </aside>
    </>
  );
};

export default VitalsRecords;
